<template>
  <div class="row">
    <div
      class="col-xl-4 col-lg-6 col-md-4 col-sm-12 flex-fill"
      v-for="pagamento of formasDePagamento"
      :key="pagamento.id"
    >
      <label
        :for="pagamento.id"
        class="payment-card"
        v-if="pagamento.nome === 'Cartão de crédito'"
      >
        <input
          class="payment-input"
          type="radio"
          name="radioNoLabel"
          :id="pagamento.id"
          v-model="formasDePagamentoDefinido"
          :value="pagamento.nome"
        />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <span class="text-bold payment-name">{{ pagamento.nome }} </span>
              <i class="fab fa fa-credit-card fa-lg text-primary ml-2"></i>
            </div>
            <div class="row text-muted small mt-1">
              {{ pagamento.descricao }}
            </div>
          </div>
        </div>
      </label>
      <label
        :for="pagamento.id"
        class="payment-card"
        v-if="pagamento.nome === 'Pix'"
      >
        <input
          class="payment-input"
          type="radio"
          name="radioNoLabel"
          :id="pagamento.id"
          v-model="formasDePagamentoDefinido"
          :value="pagamento.nome"
        />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <span class="text-bold payment-name">{{ pagamento.nome }}</span>
              <div
                style="
                  display: inline-block;
                  background-color: #194175;
                  padding: 1px;
                  border-radius: 4px;
                "
                class="text-primary ml-2"
              >
                <svg
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  class="custom-svg"
                  style="
                    width: 1.333em;
                    height: 1.333em;
                    vertical-align: -0.125em;
                    fill: #fff;
                  "
                >
                  <g fill="#fff" fill-rule="evenodd">
                    <path
                      d="M112.57 391.19c20.056 0 38.928-7.808 53.12-22l76.693-76.692c5.385-5.404 14.765-5.384 20.15 0l76.989 76.989c14.191 14.172 33.045 21.98 53.12 21.98h15.098l-97.138 97.139c-30.326 30.344-79.505 30.344-109.85 0l-97.415-97.416h9.232zm280.068-271.294c-20.056 0-38.929 7.809-53.12 22l-76.97 76.99c-5.551 5.53-14.6 5.568-20.15-.02l-76.711-76.693c-14.192-14.191-33.046-21.999-53.12-21.999h-9.234l97.416-97.416c30.344-30.344 79.523-30.344 109.867 0l97.138 97.138h-15.116z"
                    />
                    <path
                      d="M22.758 200.753l58.024-58.024h31.787c13.84 0 27.384 5.605 37.172 15.394l76.694 76.693c7.178 7.179 16.596 10.768 26.033 10.768 9.417 0 18.854-3.59 26.014-10.75l76.989-76.99c9.787-9.787 23.331-15.393 37.171-15.393h37.654l58.3 58.302c30.343 30.344 30.343 79.523 0 109.867l-58.3 58.303H392.64c-13.84 0-27.384-5.605-37.171-15.394l-76.97-76.99c-13.914-13.894-38.172-13.894-52.066.02l-76.694 76.674c-9.788 9.788-23.332 15.413-37.172 15.413H80.782L22.758 310.62c-30.344-30.345-30.344-79.524 0-109.868"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div class="row text-muted small mt-1">
              {{ pagamento.descricao }}
            </div>
          </div>
        </div>
      </label>
      <label
        :for="pagamento.id"
        class="payment-card"
        v-if="pagamento.nome === 'Boleto'"
      >
        <input
          class="payment-input"
          type="radio"
          name="radioNoLabel"
          :id="pagamento.id"
          v-model="formasDePagamentoDefinido"
          :value="pagamento.nome"
        />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <span class="text-bold payment-name">{{ pagamento.nome }}</span>
              <i class="fab fa fa-barcode fa-lg text-primary ml-2"></i>
            </div>

            <div class="row text-muted small mt-1">
              {{ pagamento.descricao }}
            </div>
          </div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import FormasPagamento from './js/formasPagamento'
export default FormasPagamento
</script>

<style scoped>
  @import "./scss/formulario.scss";
</style>
